import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {BaseUIController} from '../base-ui-controller';
import { ClickOutsideDirective } from '../../../Directives/clickOutside.directive';
import { NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

interface IColorWithDarkness {
  color: string;
  isDark: boolean;
}

@Component({
    selector: 'ins-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss', '../shared-UI-components.scss'],
    imports: [ClickOutsideDirective, NgStyle, MatIcon]
})
export class ColorPickerComponent extends BaseUIController implements OnInit {

  @Input() colorList: IColorWithDarkness[] = [
    {color: 'ff0000', isDark: true},
    {color: '3cb44b', isDark: false},
    {color: 'ffe119', isDark: false},
    {color: '0082c8', isDark: true},
    {color: 'f58231', isDark: false},
    {color: '911eb4', isDark: true},
    {color: '46f0f0', isDark: false},
    {color: 'd2f53c', isDark: false},
    {color: 'fabebe', isDark: false},
    {color: '008080', isDark: true},
    {color: 'aa6e28', isDark: true},
    {color: 'fffac8', isDark: false},
    {color: '800000', isDark: true},
    {color: 'aaffc3', isDark: false},
    {color: '808000', isDark: true},
    {color: 'ffd8b1', isDark: false},
    {color: '000080', isDark: true},
    {color: '808080', isDark: true},
    {color: 'FFFFFF', isDark: false},
    {color: '000000', isDark: true}];

  @Input() enableEmptyColor: boolean = true;

  showSelector: boolean = false;
  selectorPosition: any = {};
  selectedColor: any = {};
  @Input() label: string = '';
  @Input() showDefaultSelector: boolean = false;

   private isDark(hexColor) {
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);
    const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    const threshold = 0.8;
    return luminance < threshold;
  }

  @Output() colorConfigChange: any = new EventEmitter<any>();

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    let textColor: string = 'black';
    if (this.value !== '') {
      textColor = this.isDark(this.value) ? 'white' : 'black';
    }
    this.setSelectedColor(this.value, textColor, 'black');
  }

  toggleSelector(colorButton: any): void {
    if (this.showSelector) {
      this.showSelector = false;
      return;
    }
    this.selectorPosition['top'] = colorButton.getBoundingClientRect().top + 24 + 'px';
    this.selectorPosition['left'] = colorButton.getBoundingClientRect().left + 16 + 'px';

    this.showSelector = true;
  }

  closePopup(): void {
    this.showSelector = false;
  }

  onColorPicked(event: any): void {
    this.value = event;
    this.showSelector = false;
    let textColor: string = 'black';
    let borderColor: string = 'black';
    if (this.value !== '') {
      textColor = this.isDark(this.value) ? 'white' : 'black';
      borderColor = this.value;
    }
    this.setSelectedColor(this.value, textColor, borderColor);
  }

  clickOutside(): void {
    this.showSelector = false;
  }

  specifyColor(index: number): any {
    return {'background-color' : '#' + this.colorList[index].color};
  }

  emptyColor(): void {
    this.value = '';
    this.showSelector = false;
    this.setSelectedColor('initial', 'black', 'black');
  }

  setSelectedColor(bgColor: string, textColor: string, borderColor: string): void {
    this.selectedColor = {'bgColor' : bgColor, 'color' : textColor, 'borderColor': borderColor};
    this.colorConfigChange.emit(this.selectedColor);
  }

  public getIconName(): string {
    return this.showSelector ? 'dropdown.expand-less' : 'dropdown.expand-more';
  }
}
